/**
 * Portal Manta · agConclusao
 * Extraído de App.jsx v29.3 (via AST)
 */
import React, { useState, useEffect, useMemo, useCallback, Fragment, memo } from 'react';
import { sumBy, pct } from '../../globals.js';

function agConclusao(ctx, prev){
  const {lote, sig, cf, od, ext} = ctx;
  const totSicro = Object.values(cf).reduce((s,arr)=>s+sumBy(arr,'v'),0);
  const comp = prev?.comparador || {};
  const ratio = ((lote.capex_total_b||0)*1e9) ? totSicro/((lote.capex_total_b)*1e9) : 0;
  const rkm = ext ? totSicro/ext : 0;
  const benchmark_rkm_pr = 1340000;
  const desvio_pct = benchmark_rkm_pr ? (rkm/benchmark_rkm_pr - 1)*100 : 0;
  const disciplinas = Object.entries(cf).map(([d,items])=>({d,v:sumBy(items,'v')})).sort((a,b)=>b.v-a.v);
  const top3disc = disciplinas.slice(0,3);
  const dupKm = sumBy(od.duplicacoes||[],'km')+sumBy(od.contornos||[],'km');
  const dupPct = ext?dupKm/ext*100:0;
  const oaeN = sumBy(od.oaes||[],'n');
  const oaeDens = ext?oaeN/ext:0;
  const interN = sumBy(od.diamantes||[],'n')+sumBy(od.trombetas||[],'n')+sumBy(od.parclos||[],'n')+sumBy(od.rotatorias||[],'n');
  const cicKm = sumBy(od.ciclovias||[],'km');
  const margKm = sumBy(od.marginais||[],'km');
  const passN = sumBy(od.passarelas||[],'n');
  const urbano = (margKm > 5) || (passN > 5) || (cicKm > 10);
  const contexto = urbano ? 'Periurbano/Urbano (margens, passarelas, ciclovias relevantes)' : 'Predominantemente rural';
  const drivers = [];
  if(dupPct > 30) drivers.push('alta % de duplicação ('+dupPct.toFixed(1)+'%)');
  if(oaeDens > 0.3) drivers.push('alta densidade de OAEs ('+oaeDens.toFixed(2)+'/km)');
  if(top3disc[0]) drivers.push(`disciplina dominante: ${top3disc[0].d} (${(top3disc[0].v/totSicro*100).toFixed(1)}%)`);
  const exec = `Lote ${sig} · ${ext.toFixed(1)} km · CAPEX R$ ${(lote.capex_total_b||0).toFixed(2)} bi · SICRO R$ ${(totSicro/1e6).toFixed(1)} mi (${(ratio*100).toFixed(1)}% do CAPEX). R$/km de obra direta: R$ ${(rkm/1000).toFixed(0)} mil (${desvio_pct>=0?'+':''}${desvio_pct.toFixed(1)}% vs benchmark PR). Contexto: ${contexto}. Drivers principais: ${drivers.join(', ') || '—'}.`;
  return {
    sub:'Conclusão',
    status:'ok',
    executive: exec,
    quantitativa: {
      capex_total_bi: (lote.capex_total_b||0).toFixed(2),
      sicro_total_mi: (totSicro/1e6).toFixed(1),
      sicro_capex_ratio: (ratio*100).toFixed(1),
      rkm_lote: (rkm/1000).toFixed(0),
      rkm_benchmark: (benchmark_rkm_pr/1000).toFixed(0),
      desvio_vs_benchmark_pct: desvio_pct.toFixed(1),
    },
    qualitativa: {
      contexto, drivers,
      top3_disciplinas: top3disc.map(d=>({nome:d.d, valor_mi:(d.v/1e6).toFixed(1), pct:(d.v/totSicro*100).toFixed(1)})),
    },
    integracoes: {
      comparador_status: comp.status || 'não rodado',
      inconsistencias_count: comp.inconsistencias?.length || 0,
    },
  };
}

export { agConclusao };
export default agConclusao;
